import { useEffect, useState } from 'react';
import { API_ENDPOINTS, buildApiUrl } from '../config/api';
import { useLanguage } from '../contexts/LanguageContext';
import { notifySupportApiNetworkError, notifySupportApiServerError } from '../utils/supportApiErrorNotifier';

export const useAccessories = (vehicleModelId = null) => {
  const [accessories, setAccessories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { language } = useLanguage();

  useEffect(() => {
    const fetchAccessories = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Si se proporciona un modelId, obtener solo los accesorios compatibles
        const endpoint = vehicleModelId 
          ? `${API_ENDPOINTS.ACCESSORIES}/model/${vehicleModelId}`
          : API_ENDPOINTS.ACCESSORIES;
        
        // Incluir el idioma en la petición
        const url = `${buildApiUrl(endpoint)}?lang=${language}`;
        const response = await fetch(url);
        
        if (!response.ok) {
          notifySupportApiServerError(response.status);
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        }
        
        const data = await response.json();
        setAccessories(data);
      } catch (err) {
        notifySupportApiNetworkError(err);
        console.error('Error fetching accessories:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAccessories();
  }, [vehicleModelId, language]); // Se ejecuta cuando cambia el vehicleModelId o el idioma

  return { accessories, loading, error };
}; 